import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {
    changeOrderAddress2,
    changeOrderMultipleValues,
    changeOrderName,
    changeOrderProducts,
    changeOrderRecipient,
    changeOrderShippingMethod,
    changeOrderWarehouse,
    onCreateEmptyOrder,
    onCreateOrderFulfilled,
    onCreateOrderPending,
    onCreateOrderRejected,
    onCreateUnannouncedOrderFulfilled
} from "../reducers/new-order-reducer";
import {OrderModel} from "../../pages/shared/models/order/order-item.model";
import ordersService from "../../services/orders.service";
import Joi from "joi";
import {ResponseStatus} from "../../actions/types";
import {OrderUpdateDataModel} from "../../management-pages/actions/dialogs/add-product/add-product";

export const createOrder = createAsyncThunk(
    'createOrder',
    async (props: {order: OrderModel, languageId: number}) => {
        return await ordersService.createOrder(props.order, props.languageId);
    }
)

export const createUnannouncedOrder = createAsyncThunk(
    'createUnannouncedOrder',
    async (props: {order: OrderUpdateDataModel, languageId: number}) => {
        return await ordersService.createUnannouncedOrder(props.order, props.languageId);
    }
)

export const newOrderSlice = createSlice({
    name: "new-order",
    initialState: {
        newOrder: undefined,
        newUnannouncedOrder: undefined,
        isLoading: false,
        errors: {} as {[key: string]: Joi.ValidationErrorItem}
    } as NewOrderSlice,
    reducers: {
        newOrderSetWarehouse: changeOrderWarehouse,
        newOrderSetShippingMethod: changeOrderShippingMethod,
        newOrderSetName: changeOrderName,
        newOrderSetAddress2: changeOrderAddress2,
        newOrderSetRecipient: changeOrderRecipient,
        newOrderSetProducts: changeOrderProducts,
        newOrderUpdateMultiple: changeOrderMultipleValues,
        createEmptyOrder: onCreateEmptyOrder,
        clearNewOrder: (state) => {state.newOrder = undefined},
    },
    extraReducers: (builder) => {
        builder.addCase(createOrder.pending, state  => onCreateOrderPending(ResponseStatus.PENDING, null, state));
        builder.addCase(createOrder.fulfilled, (state, action)  => onCreateOrderFulfilled(ResponseStatus.SUCCESS, action.payload, state));
        builder.addCase(createOrder.rejected, (state, action)  => onCreateOrderRejected(ResponseStatus.FAIL, action.payload, state));
        builder.addCase(createUnannouncedOrder.fulfilled, (state, action)  => onCreateUnannouncedOrderFulfilled(ResponseStatus.SUCCESS, action.payload, state));
    }
})

export interface NewOrderSlice {
    newOrder: undefined | OrderModel;
    isLoading: boolean,
    errors: {[key: string]: Joi.ValidationErrorItem}
}

export default newOrderSlice.reducer;

export const {newOrderSetWarehouse, newOrderSetShippingMethod, newOrderSetRecipient, newOrderSetName, newOrderSetAddress2, newOrderSetProducts, newOrderUpdateMultiple, createEmptyOrder, clearNewOrder} = newOrderSlice.actions;
